@if (step === filtersModalSteps.menu && !isOnlyFiltersList) {
  <app-filters-menu
    [menuOptions]="menuOptions"
    [initialFilters]="initialFilters"
    [withFavoriteOption]="withFavoriteOption"
    [onlyFavorite]="onlyFavorite"
    [isFiltersChosen]="filtersStateHaveOptions$ | async"
    (emitSelectedMenuOption)="goToFiltersList($event)"
  >
  </app-filters-menu>
}
@if (step === filtersModalSteps.filterList || isOnlyFiltersList) {
  <app-filters-list
    [isOnlyFiltersList]="isOnlyFiltersList"
    [activeFilterList]="activeFilterList"
    [initialFilters]="initialFilters"
    [isCheckboxType]="isCheckboxType"
    (emitStepChange)="step = filtersModalSteps.menu"
  ></app-filters-list>
}
